import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import { GenerateThink5whysCodeSignup } from "./GenerateThink5whysCodeSignup";
import Loader from "./utils/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const SignupForm = () => {
  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    think5whyscode: "",
    recoveryToken: "",
  });
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateManyFields = (type, data) => {
    const errors = [];

    if (type === "signup") {
      if (!data.email) {
        errors.push({ field: "email", err: "Email is required" });
      } else if (!validateEmail(data.email)) {
        errors.push({ field: "email", err: "Invalid email format" });
      } else if (!data.recoveryToken) {
        errors.push({ field: "recoveryToken", err: "Invalid recovery token" });
      }
      if (!data.password || data.password.length < 8) {
        errors.push({
          field: "password",
          err: "Password must be at least 8 characters",
        });
      }
      if (!data.name || data.name.length < 2) {
        errors.push({
          field: "name",
          err: "Name must be at least 2 characters",
        });
      }
      if (!data.recoveryToken || data.recoveryToken.length != 6 ) {
        errors.push({
          field: "recoveryToken",
          err: "Your Password Recovery Token must of 6 characters",
        });
      }
    }

    return errors;
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateManyFields("signup", formData);

    setFormErrors({});
    if (errors.length > 0) {
      setFormErrors(
        errors.reduce((total, ob) => ({ ...total, [ob.field]: ob.err }), {})
      );
      return;
    }
    const code = GenerateThink5whysCodeSignup();
    const updatedFormData = {
      ...formData,
      think5whyscode: code,
    };

    const config = {
      url: "/auth/signup",
      method: "post",
      data: updatedFormData,
    };
    // fetchData(config).then(() => {
    //   navigate("/login");
    // });
    fetchData(config)
      .then((res) => {
        navigate("/login");
    })
    .catch((err) => {
      console.error("Signup Error:", err);

      // Show backend message
      if (err?.response?.data?.msg) {
        setFormErrors({ email: err.response.data.msg });
      } else {
        setFormErrors({ email: "Something went wrong. Try again." });
      }
    });
  };

  const fieldError = (field) => (
    <p
      className={`mt-1 !text-red-500 text-sm ${
        formErrors[field] ? "block" : "hidden"
      }`}
    >
      <i className="mr-2 fa-solid fa-circle-exclamation text-red-500"></i>
      {formErrors[field]}
    </p>
  );

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL.replace('/api', '')}/api/auth/google`;
  };

  const handleFacebookLogin = () => {
    // window.location.href = 'http://localhost:3001/auth/facebook';
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-black text-white p-2">
      <form className="w-full max-w-md mx-auto p-4 bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 
        rounded-2xl shadow-lg border border-gray-300" 
        onSubmit={(e) => e.preventDefault()}
      >
      {loading ? (
          <Loader />
        ) : (
          <>
            <h1 className="text-center text-xl font-extrabold text-blue-600 mb-4">
              Think5Whys
            </h1>

            <h2 className="text-center text-sm font-medium text-gray-700 mb-4">
              A transformational platform for all, powered by causal engineering, leveraging AI capabilities and computation.
            </h2>
            {/* <h3 className="text-center text-gray-500 mb-6">
              थोड़ा और सोचो!
            </h3> */}
            <h4 className="text-center text-sm text-blue-500 mb-6">
              Welcome Guest, Please Signup Here
            </h4>

            <div className="mb-2">
              <label
                htmlFor="name"
                className="block text-gray-800 text-xs font-semibold mb-1"
              >
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                placeholder="Your name"
                onChange={handleChange}
                className="px-4 py-2 border text-xs text-black border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                style={{width: '100%'}}
              />
              <p className="text-black mt-1 text-xs">{fieldError("name")}</p>
            </div>

            <div className="mb-2">
              <label
                htmlFor="email"
                className="block text-gray-800 text-xs font-semibold mb-1"
              >
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                placeholder="youremail@domain.com"
                onChange={handleChange}
                className="w-full px-4 py-2 text-xs text-black border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                style={{width: '100%'}}
              />
              <p className="text-black">{fieldError("email")}</p>
            </div>

            <div className="relative w-full" style={{ width: '100%' }}>
              <label
                htmlFor="password"
                className="block text-gray-800 text-xs font-semibold mb-1"
              >
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                autoComplete="current-password" 
                className="w-full px-4 py-2 pr-10 text-xs text-black border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                value={formData.password}
                onChange={handleChange}
                placeholder="Your password"
              />
             <div
                className="absolute right-3 top-[28px] flex items-center cursor-pointer text-blue-700"
                onClick={togglePasswordVisibility}
              >
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  size="sm"
                />
              </div>
              <p className="text-black">{fieldError("password")}</p>
            </div>

            {/* RECOVERY TOKEN FIELD */}
            <div className="relative w-full mt-2" style={{ width: "100%" }}>
              <label
                htmlFor="recoveryToken"
                className="block text-gray-800 text-xs font-semibold mb-1"
              >
                Password Recovery Token <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                name="recoveryToken"
                className="w-full px-4 py-2 text-xs text-black border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                value={formData.recoveryToken}
                onChange={handleChange}
                placeholder="Create a 6-character recovery code"
                maxLength={8}
              />

              <p className="text-black">{fieldError("recoveryToken")}</p>
            </div>

            <button
              type="button"
              className="mt-2 w-full bg-blue-500 text-white py-1 rounded-lg font-semibold hover:bg-blue-600 transition duration-300 ease-in-out"
              onClick={handleSubmit}
            >
              Sign Up
            </button>

            <div className="text-center mt-4">
              <Link to="/login" className="text-blue-500 hover:underline">
                Already have an account?{" "}
                <span className="font-medium">Login Here</span>
              </Link>
            </div>

            <div className="flex flex-col gap-2 mt-2">
              <button
                type="button"
                disabled
                className="w-full bg-white text-red-500 py-1 border border-red-500 rounded-lg flex items-center justify-center gap-2 font-semibold hover:bg-red-50 transition duration-300 ease-in-out"
                onClick={handleGoogleLogin}  
              >
                <FontAwesomeIcon icon={faGoogle} className="text-red-500" />
                Login with Google
              </button>
              <button
                type="button"
                className="w-full bg-blue-800 text-white py-1 rounded-lg flex items-center justify-center gap-2 font-semibold hover:bg-blue-700 transition duration-300 ease-in-out"
                disabled
                onClick={handleFacebookLogin}
              >
                <FontAwesomeIcon icon={faFacebook} className="text-white" />
                Login with Meta
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default SignupForm;
